import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { ReleaseNotesGate } from "@/components/ReleaseNotesGate";

export function ProtectedRoute({ children, adminOnly = false, catnatOnly = false }) {
  const { user, loading, isAdmin, isCatnat } = useAuth();
  if (loading || user === null)
    return (
      <div className="flex h-screen items-center justify-center bg-bone">
        <div className="h-8 w-8 animate-spin rounded-full border-2 border-forest border-t-transparent" />
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  if (isCatnat) return catnatOnly ? <>{children}<ReleaseNotesGate /></> : <Navigate to="/catnat-inbox" replace />;
  if (catnatOnly) return <Navigate to={isAdmin ? "/admin" : "/"} replace />;
  if (adminOnly && !isAdmin) return <Navigate to="/" replace />;
  if (!adminOnly && isAdmin) return <Navigate to="/admin" replace />;
  return <>{children}<ReleaseNotesGate /></>;
}
